import React from "react";
import MaterialIcon from "../BuilderComponents/MaterialIcon";

const TableCatalogTogglerPreview = ({ config, classes }) => {
  const icon = config?.table?.icon?.split(" ")[0] || "";

  return (
    <div className={`rv-download-icon d_flex align_center justify_center ${classes}`} title={config.title}>
      <MaterialIcon name={icon} />
    </div>
  );
};

export default TableCatalogTogglerPreview;
